import { createContext } from "react";

const ConsultaSeguimientoContext = createContext();

export default ConsultaSeguimientoContext;
